export const WEBAPP = 'myiute_mobile'
